import { useState, useEffect } from "react";
import Footer from "../../../components/Footer/Footer";
import InnerNav from "../../../components/InnerNav/InnerNav";
import Zodiac from "../../../components/ZodiacSign/Zodiac";
import "./Subho.scss";
import MuhuratLink from "../../../components/MuhuratLink/MuhuratLink";
import axios from "axios";
import city from '../../../city.json'


const Subho = () => {
  const [expandedMonths, setExpandedMonths] = useState({});
  const [allMonths, setAllMonths] = useState([]);

  const handleToggle = (index) => {
    setExpandedMonths((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

   const currentYear = new Date().getFullYear();
const [year, setYear] = useState(currentYear);
  const [tempLocation, setTempLocation] = useState("Kolkata");
const [suggestions, setSuggestions] = useState([]);

// temporary values (for input fields)
const [tempYear, setTempYear] = useState(currentYear);

  useEffect(() => {
    const fetchFestivalData = async () => {
      try {
        const res = await axios.get(`https://core-c343.onrender.com/api/hindu-festival?year=${year}`);
        const data = res.data.months;

        const formattedData = Object.keys(data).map((monthName) => ({
          month: `${monthName}, ${year}`,
          Subho: data[monthName].map((fest) => ({
            name: fest.name,
            date: new Date(fest.date).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            }),
            info: "", // No extra info in API, leave blank
          })),
        }));

        setAllMonths(formattedData);
      } catch (error) {
        console.error("Error fetching Subho Dates:", error);
      }
    };

    fetchFestivalData();
  }, [year]);

      const handleSubmit = () => {
  setYear(tempYear);
  
};
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

  return (
    <div className="Subho-container">
      <InnerNav />
      <div className="Subho-content">
        <Zodiac />

        <div className="location-date">
          <div className="year-selector">
            <label htmlFor="year">Select Year: </label>
            <input
              id="year"
              type="number"
              min="1900"
              max="2100"
              value={tempYear}
              onChange={(e) => setTempYear(Number(e.target.value))}
            />
            <button className="submit" onClick={handleSubmit}>Submit</button>
          </div>

           <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
        </div>
        <h1 className="Subho-title">Subha Dates Muhurat</h1>

        {allMonths.length > 0 ? (
          allMonths.map((month, index) => {
            const isExpanded = expandedMonths[index];
            const visibleSubho = isExpanded ? month.Subho : month.Subho.slice(0, 6);

            return (
              <div className="monthSubho" key={index}>
                <h2 className="month-heading">{month.month}</h2>
                <div className="list-of-Subho">
                  {visibleSubho.map((fest, i) => (
                    <div className="Subho-card" key={i}>
                      <div className="Subho-info">
                        <p className="Subho-name">{fest.name}</p>
                        <p className="Subho-date">{fest.date}</p>
                        <p className="Subho-details">{fest.info}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {month.Subho.length > 6 && (
                  <button className="toggle-btn" onClick={() => handleToggle(index)}>
                    {isExpanded ? "Show less" : "Show more"}
                  </button>
                )}
              </div>
            );
          })
        ) : (
          <p>No Subho Dates data available for the current year.</p>
        )}

        <MuhuratLink />
      </div>
      <Footer />
    </div>
  );
};

export default Subho;
